import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { BanksDTO } from "../banks-DTO";
import { useAlert } from "../../../../../contexts/alert-context";
import { addNew, getById } from "../banks-service";
import CountryInputAutocomplete from "../../../../../components/CountryInputAutocomplete/CountryInputAutocomplete";
import { CountryConfigDTO } from "../../Country-config/country-config-DTO";


interface ModalProps {
  onClose: () => void;
  requirementId: string;
}

const BanksForm: React.FC<ModalProps> = ({ onClose, requirementId }) => {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const { setAlert } = useAlert();
  const [banksDTO, setBanksDTO] = useState<BanksDTO | null>(null);
  const [country, setCountry] = useState<string | null>(null);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm<BanksDTO>();

  useEffect(() => {
    if (requirementId) {
      getById(requirementId).then((data) => {
        if (data) {
          Object.entries(data).forEach(([key, value]) => {
            if (typeof value === "object" && value !== null) {
              Object.entries(value as Record<string, unknown>).forEach(
                ([subKey, subValue]) => {
                  setValue(
                    `${key}.${subKey}` as keyof BanksDTO,
                    subValue as any
                  );
                }
              );
            } else {
              setValue(key as keyof BanksDTO, value as any);
            }
          });

          setValue("banksInfoDTO.country", data.banksInfoDTO.country);
          setCountry(data.banksInfoDTO.country[0]);
        }
      });
    }
  }, [id, setValue, country]);

  const onSubmit = async (document: BanksDTO) => {
    try {
      if (id) {
        await addNew(document, id);
        setAlert({ text: t("alert-successfully-registered"), type: "success" });
        onClose();
      }
    } catch (e) {
      console.error("Erro ao cadastrar: ", e);
      setAlert({ text: `${t("alert-error-registered")}:`, type: "error" });
    }
  };
  const [selectedCountryDetails, setSelectedCountryDetails] =
    useState<CountryConfigDTO | null>(null);

  const handleCountryChange = (country: CountryConfigDTO) => {
    setSelectedCountryDetails(country);

    setValue("banksInfoDTO.country", country.country, {
      shouldValidate: true,
    });
  };

  return (
    <div className="modal-content">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="form-fields flex-column">
          <h2>{t("label-bank")}</h2>
          <div className="flex-column">
            <CountryInputAutocomplete
              label={`${t("label-country")}*`}
              placeholder={t("placeholder.country")}
              register={register}
              errors={errors}
              onChange={handleCountryChange}
              initialValue={country}
            />
            {!selectedCountryDetails && (
              <span>{t("error-input-required")}</span>
            )}
          </div>
          <div className="flex-column">
            <label htmlFor="label-bank">{`${t("label-bank")}*`}</label>
            <input
              placeholder={t("placeholder.generalEmpty")}
              type="text"
              id="label-bank"
              {...register("banksInfoDTO.name", {
                required: true,
              })}
            />
            {errors.banksInfoDTO?.name && (
              <span>{t("error-input-required")}</span>
            )}
          </div>

          <div className="flex-column">
            <label htmlFor="label-code">{`${t("label-code")}*`}</label>
            <input
              placeholder={t("placeholder.generalEmpty")}
              type="text"
              id="label-code"
              {...register("banksInfoDTO.code", {
                required: true,
              })}
            />
            {errors.banksInfoDTO?.code && (
              <span>{t("error-input-required")}</span>
            )}
          </div>
        </div>
        <br />

        <div className="form-fields flex-column">
          <div className="flex-column">
            <label htmlFor="observations" style={{ paddingBottom: 10 }}>
              {t("label-general-observations")}
            </label>
            <textarea
              placeholder={t("placeholder.observations")}
              id="observations"
              {...register("observations.observations")}
            />
          </div>
        </div>

        <div className="flex-row buttons-section">
          <button className="neutral-white" onClick={onClose} type="button">
            {t("label-back")}
          </button>
          <button className="blue" type="submit">
            {t("label-save")}
          </button>
        </div>
      </form>
    </div>
  );
};

export default BanksForm;
